/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OdChargeIdEnum = 'CFS-GIB' | 'DAT-TIB' | 'DAT-VM' | 'DAT-SVM' | 'DAT-RWR' | 'RWR-EDR-CB' | 'RWR-EDR-CS' | 'HOST-HOURS' | 'SDDC-HOURS';

export const OdChargeIdEnum = {

    CFS_GIB: 'CFS-GIB' as OdChargeIdEnum,

    DAT_TIB: 'DAT-TIB' as OdChargeIdEnum,

    DAT_VM: 'DAT-VM' as OdChargeIdEnum,

    DAT_SVM: 'DAT-SVM' as OdChargeIdEnum,

    DAT_RWR: 'DAT-RWR' as OdChargeIdEnum,

    RWR_EDR_CB: 'RWR-EDR-CB' as OdChargeIdEnum,

    RWR_EDR_CS: 'RWR-EDR-CS' as OdChargeIdEnum,

    HOST_HOURS: 'HOST-HOURS' as OdChargeIdEnum,

    SDDC_HOURS: 'SDDC-HOURS' as OdChargeIdEnum
};

